import { render, staticRenderFns } from "./TabCustomization.vue?vue&type=template&id=0c4c7472&scoped=true"
import script from "./TabCustomization.vue?vue&type=script&lang=js"
export * from "./TabCustomization.vue?vue&type=script&lang=js"
import style0 from "./TabCustomization.vue?vue&type=style&index=0&id=0c4c7472&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c4c7472",
  null
  
)

export default component.exports